import React, { useEffect, useState } from "react";
import "../../Styles/Pages/Profile.css";
import Topbar from "../../Layouts/Admin_layout/Admin_topbar";
import { Typography, Grid, Avatar } from "@mui/material";
import instance from "../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import profile from "../../Assets/profile.jpg";

function Profile() {
  const [vendor, setVendor] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();

  const fetchVendorDetails = async () => {
    try {
      const response = await instance.get("/vendor/getVendorDetails");
      setVendor(response.data.vendor);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchVendorDetails();
  }, []);

  return (
    <div style={{ padding: "20px 20px 0px 0px" }}>
      <Topbar />
      <div className="profile-back-btn-mains">
        <div
          className="profile-back-btn"
          onClick={() => navigate("/admin/Dashboard")}
        >
          Back
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="profile-pic">
            {" "}
            <Avatar sx={{ width: "200px", height: "200px" }} />{" "}
          </div>
          <Grid>
            <div className="name-field">
              <Typography>
                <strong>Name : </strong>
              </Typography>
              <Typography>{vendor.name}</Typography>
            </div>
          </Grid>
          <Grid>
            <div className="name-field">
              <Typography>
                <strong>Company : </strong>
              </Typography>
              <Typography>{vendor.companyname}</Typography>
            </div>
          </Grid>
          <Grid>
            <div className="email-field">
              <Typography>
                <strong>Email : </strong>
              </Typography>
              <Typography>{vendor.email}</Typography>
            </div>
          </Grid>
          <Grid>
            <div className="mobile-field">
              <Typography>
                <strong>Mobile : </strong>
              </Typography>
              <Typography>{vendor.mobile_no}</Typography>
            </div>
          </Grid>
        </div>
      </div>
    </div>
  );
}

export default Profile;
